import React, { useEffect } from 'react';
import { useHistory, useRouteMatch } from 'react-router';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Drawer,
  Hidden,
  makeStyles,
} from '@material-ui/core';
import { Tab } from 'src/types';
import { routeTabs } from 'src/utils/routeTabs';
import Toolbar from './Toolbar';
import SideNav from '../../SideNav';

const useStyles = makeStyles((theme) => ({
  drawerDesktopRoot: {
    width: 280,
    flexShrink: 0
  },
  drawerDesktopPaper: {
    position: 'relative'
  },
  drawerMobilePaper: {
    position: 'relative',
    width: 280,
    overflow: 'scroll',
  },
  drawerMobileBackdrop: {
    position: 'absolute'
  },
  filePlusIcon: {
    marginLeft: theme.spacing(1)
  },
  box: {
    overflow: 'hidden',
    paddingBottom: 64, // same as height of the toolbar
  }
}));

interface Props {
  containerRef?: any,
  tabs: Tab[],
  title?: string,
  rootUrl: string,
}

function Sidebar({
  containerRef, tabs, title, rootUrl, ...rest
}: Props) {
  const routedTabs = routeTabs(tabs, rootUrl);
  const classes = useStyles();
  const history = useHistory();

  const content = (
    <div className={classes.box}>
      {title && <Toolbar rootUrl={rootUrl} title={title} openEngagementActions={() => history.push(`${rootUrl}/engagement-actions`)} />}
      <PerfectScrollbar options={{ suppressScrollX: true }}>
        <SideNav
          tabs={routedTabs}
          {...rest}
        />
      </PerfectScrollbar>
    </div>
  );

  return (
    <>
      <Hidden smDown>
        <Drawer
          variant="permanent"
          classes={{
            root: classes.drawerDesktopRoot,
            paper: classes.drawerDesktopPaper
          }}
        >
          {content}
        </Drawer>
      </Hidden>
      <Hidden mdUp>
        <Drawer
          variant="temporary"
          // open={sidebarOpen}
          classes={{
            paper: classes.drawerMobilePaper
          }}
          style={{ position: 'absolute', zIndex: 1200 }}
          BackdropProps={{ classes: { root: classes.drawerMobileBackdrop } }}
          ModalProps={{ container: () => containerRef.current }}
        >
          {content}
        </Drawer>
      </Hidden>
    </>
  );
}

export default Sidebar;
